










import Vue from 'vue';

interface IVTextField extends Element {
  blur(): void;
}

export default Vue.extend({
  name: 'AutoBlurTextField',
  data() {
    return {
      scrollBindingTimer: undefined as number | undefined,
    };
  },
  methods: {
    onOutsideScroll(e: Event) {
      if (this.$vuetify.breakpoint.smAndDown) {
        const textfield = this.$refs.textField as IVTextField;
        textfield.blur();
      }
    },
    bindScroll() {
      // We have to defer the binding because on mobile the keyboard will take a fraction
      // of a second to appear and cause a scroll event to fire.
      // Without the delay, the scroll would inadvertently cause the blur to fire and the
      // keyboard to close immediately
      this.scrollBindingTimer = window.setTimeout(() => {
        document.addEventListener('scroll', this.onOutsideScroll, {
          capture: true,
        });
      }, 300);
    },
    unbindScroll() {
      window.clearTimeout(this.scrollBindingTimer);
      this.scrollBindingTimer = undefined;
      document.removeEventListener('scroll', this.onOutsideScroll, {
        capture: true,
      });
    },
    onFocus() {
      this.bindScroll();
    },
    onBlur() {
      this.unbindScroll();
    },
  },
  beforeDestroy() {
    this.unbindScroll();
  },
});
